import React, {
  ReactNode,
  useEffect,
  useRef,
  useState,
  forwardRef,
} from "react";
import PaginationComponet from "./PaginationComponet";
import { CircularProgress } from "@mui/material";
import { CHECKBOX_INPUT } from "src/lib/constans";
import PrimaryBtn from "./primaryBtn";

type checkBoxTypes = "unchecked" | "checked" | "indeterminate";

interface ITableWrapperProps {
  isLoading?: boolean;
  page?: number;
  total: number;
  thead: Array<string>;
  onChange?: (page: number) => void; // Define the type of the onChange function
  children?: ReactNode; // Use ReactNode for children prop
  columnWidth?: string; // Define the type for columnWidth
  selectedRows?: string[]; // 11/12/2024 for bulk actions
  totalLength?: number; // 11/12/2024 for bulk actions
  clearAll?: () => void; // 11/12/2024 for bulk actions
  selectAll?: () => void; // 11/12/2024 for bulk actions
  disabledCheckbox?: boolean;
  tableBtn?: {
    btnText: string;
    btnOnClick: () => void;
  };
}

const TableWrapper: React.FC<ITableWrapperProps> = (
  {
    isLoading = false,
    page = 1,
    total = 0,
    thead = [],
    onChange = () => {},
    children,
    columnWidth = "auto", // Default to "auto" if not provided
    selectedRows = [],
    totalLength = 10,
    clearAll = () => {},
    selectAll = () => {},
    disabledCheckbox = false,
    tableBtn = null,
  },
  ref
) => {
  const centeredElements = [
    "Health Profile",
    "Status",
    "Image",
    "Proof Document",
  ];

  const checkboxRef = useRef<HTMLInputElement>(null);
  const [checkState, setCheckState] = useState<checkBoxTypes>("unchecked");
  const toggleCheckbox = () => {
    if (checkState === "unchecked") {
      setCheckState("checked");
      selectAll();
    } else {
      setCheckState("unchecked");
      clearAll();
    }
  };
  useEffect(() => {
    if (!selectedRows.length) {
      setCheckState("unchecked");
    } else if (selectedRows.length === totalLength) {
      setCheckState("checked");
    } else {
      setCheckState("indeterminate");
    }
  }, [selectedRows]);
  useEffect(() => {
    if (checkboxRef.current) {
      checkboxRef.current.indeterminate = checkState === "indeterminate";
    }
  }, [checkState]);

  return (
    <>
      <div className="w-full" id="printableDiv">
        <ul
          id="table-inner"
          className="thead-light-table"
          style={{ gridTemplateColumns: columnWidth }}
        >
          {thead.map((v, i) => {
            return (
              <li
                className="font-size-16px font-Poppins-SemiBold"
                style={
                  centeredElements.includes(v)
                    ? { justifyContent: "center", paddingLeft: 0 }
                    : {}
                }
                key={i}
              >
                {v === CHECKBOX_INPUT ? (
                  <input
                    type="checkbox"
                    className="w-4 h-4"
                    ref={checkboxRef}
                    checked={checkState === "checked"}
                    onChange={toggleCheckbox}
                    id={`select-all-checkbox`}
                    disabled={disabledCheckbox}
                  />
                ) : (
                  v
                )}
              </li>
            );
          })}
        </ul>
        {isLoading ? (
          <ul className="font-size-16px tbody-light-table font-Poppins-Regular grid">
            <li>
              <CircularProgress
                style={{ width: 24, height: 24, color: "#00443f" }}
              />
            </li>
          </ul>
        ) : (
          <></>
        )}
        {total ? (
          children
        ) : (
          <ul className="font-size-16px tbody-light-table font-Poppins-Regular grid">
            <li>No Results</li>
          </ul>
        )}
      </div>
      {/* pagination */}
      <div className="w-full flex justify-between items-center">
        <PaginationComponet
          currentPage={page}
          total={total}
          setCurrentPage={onChange}
        />
        {tableBtn && (
          <PrimaryBtn
            ButtonText={tableBtn.btnText}
            onClick={tableBtn.btnOnClick}
            btnExtraStyle={{
              backgroundColor: "#00443F",
              color: "white",
              borderRadius: 50,
            }}
          />
        )}
      </div>
    </>
  );
};

export default TableWrapper;
